module.exports = __webpack_public_path__ + "static/media/intro-3.e6851309.png";